import { InputFeedback } from "waapi/waap-ui/components/InputFeedback/InputFeedback.js";
import { Select } from "waapi/waap-ui/components/Select/index.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { FieldContent, FieldText } from "./style.js";
import { BaseSelectProps } from "./types.js";

export const BaseSelect = <Value extends string>({ labelInfos, feedback, fullWidth, ...attributes }: BaseSelectProps<Value>): JSX.Element => {
    return (
        <FieldContent fullWidth={fullWidth}>
            {labelInfos && (
                <FieldText color={labelInfos.color} size={TextSize["X-SMALL"]} weight={TextWeight.SEMIBOLD}>
                    {labelInfos.text}
                </FieldText>
            )}

            <Select {...attributes} />

            {feedback && <InputFeedback {...feedback} />}
        </FieldContent>
    );
};
